import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import {
    Box,
    Container,
    Link as MuiLink,
    Typography
} from '@mui/material';

const NotFound = () => (
    <>
        <Helmet>
            <title>404</title>
        </Helmet>
        <Box
            sx={{
                backgroundColor: 'background.default',
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                justifyContent: 'center'
            }}
        >
            <Container maxWidth="md" align="center">
                <Typography color="textPrimary" variant="h1">404</Typography>
                <MuiLink component={Link} to="/">Return to Main Page</MuiLink>
            </Container>
        </Box>
    </>
);

export default NotFound;
